import {
    Button,
    Checkbox,
    Dialog,
    FormControl,
    FormControlLabel,
    FormHelperText,
    SwipeableDrawer,
} from '@material-ui/core';
import { connect, useDispatch } from 'react-redux';
import SwitchRight from '../Switch/SwitchRight';
import { useFormik } from 'formik';
import {
    sipType,
    _schemeDetailsNewType,
} from '../../../../redux-store/types/commercialTransactions';
import React, { useState, useEffect } from 'react';
import { InvestMentMode } from '../Switch/InvestmentMode';
import { formatRtaResponse, isSipAllowed, sortSip } from '../utils';
import { useHistory } from 'react-router';
import en from '../../../../lang/en-us';
import { IsAllow, PlanTypes } from '../../../../redux-store/types/portfolio';
import { getNewSchemeDetail } from '../../../../redux-store/actions/commercialTransactions';
import { sendPhoneOTP } from '../../../../redux-store/actions/nct';
import {
    schemeDetailsRequestType,
    schemeDetailsResponseType,
} from '../../../../redux-store/types/commercialTransactions';
import { InstallmentFieldsType, STPAPIRequestType, STPAPIResponseType, STPPaths } from './types';
import {
    InvestLowerValidationScheme,
    InvestUpperValidationSchema,
    parseToAPIStructure,
} from './utils';
import { SubmitButtonWithLoader } from '../../../../lib/Button';
import InstallmentFields from './InstallmentFields';
import { DEFAULT_MAX_INVESTMENT, OTP_ACTIONS } from '../../../../utils/constants';
import { SwitchBy } from '../Switch/SwitchInvestment';
import IdcwOptions, { idcwDetailsType } from '../IdcwOptions';
import { RootStateType } from '../../../../redux-store/reducers';
import { CommercialRootPath } from '../routeConfig';
import { ArnPayloadType, PaymentTypes } from '../ExploreMFs/types';
import { validateArn } from '../../../../redux-store/actions/newPurchase';
import { isRegular, RtaSchemeLoadingDialog } from '../AdditionalPurchase/ap-invest';
import { NIPPON_MAX_AMOUNT } from '../ExploreMFs/mf-investment';
import { NomineePopup } from '../../NomineePopup';

const { dbCommercial, common } = en;

type Props = {
    getNewSchemeDetail: ({
        isin,
        amcCode,
    }: schemeDetailsRequestType) => Promise<schemeDetailsResponseType>;
    sendPhoneOTP: any;
};

enum InvestThrough {
    arn,
    ria,
    direct,
}

enum ArnPayloadKeys {
    ARN = 'ARN',
    EUIN = 'E',
    RIA = 'INA',
}

export type Values = {
    investThrough: InvestThrough;
    riaCode: string;
    arn1: string;
    arn2: string;
    arn3: string;
    euin: IsAllow | string;
    euinCode: string;
    euinDeclaration: boolean;
    redemableUnitsOrAmount: number;
    switchFullAmount: boolean;
    switchedTo: SwitchBy;
    isChecked: boolean;
    riaFlag: string;
};

const getInitValues = (fromScheme: any, toScheme: any) => {
    let brokerCode = fromScheme.brokerCode?.replace('ARN-', '') || '';
    brokerCode = brokerCode.search('-') === -1 ? brokerCode : '';
    return {
        investThrough: isRegular(toScheme.plan) ? InvestThrough.arn : InvestThrough.direct,
        riaCode: '',
        arn1: isRegular(fromScheme.planMode) ? brokerCode : '',
        arn2: '',
        arn3: '',
        euin: '',
        euinCode: '',
        euinDeclaration: false,
        redemableUnitsOrAmount: '' as unknown as number,
        switchFullAmount: false,
        switchedTo: SwitchBy.Amount,
        isChecked: false,
        riaFlag: ArnPayloadKeys.RIA,
    };
};

export const installmentInitialValues: InstallmentFieldsType = {
    multiples: 1,
    installmentKey: {
        installment: 1,
        maxAmount: DEFAULT_MAX_INVESTMENT,
        minAmount: 1,
    },
    frequency: '',
    installmentError: false,
    installmentDay: '',
    fromDate: new Date(),
    toDate: new Date(),
    stpType: '',
    amount: '',
    numInstallments: 1,
    perpetual: false,
};

const STPInvestment: React.FunctionComponent<Props> = (props) => {
    //to-do add types.
    const history = useHistory<any>();

    const { stpFromScheme, stpToScheme } = history.location.state || {};
    const amcCode = new URLSearchParams(history.location.search).get('amc');

    if (!stpFromScheme || !stpToScheme) return null;

    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const [stpDetails, setStpDetails] = useState<sipType | null>(null);
    const [idcwDetails, setIdcwDetails] = useState<idcwDetailsType | null>(null);
    const [commonDetails, setCommonDetails] =
        useState<_schemeDetailsNewType['commonDetails'] | null>(null);
    const [subPlanDetails, setSubPlanDetails] = useState<_schemeDetailsNewType['subPlans']>();
    const [euin, setEuin] = useState(false);
    const [show, setShow] = useState<boolean>(false);
    const [openDrawer, setDrawer] = useState<boolean>(false);
    const [installmentDiff, setInstallmentDiff] = useState<number>(1);
    const [schemeLoading, setSchemeLoading] = useState(false);

    const formik = useFormik<Values>({
        initialValues: getInitValues(stpFromScheme, stpToScheme),
        validationSchema: InvestUpperValidationSchema({
            planType: stpToScheme.plan.toUpperCase() as PlanTypes,
        }),
        onSubmit: () => {},
        validateOnMount: true,
    });

    const installmentFormik = useFormik<InstallmentFieldsType>({
        initialValues: installmentInitialValues,
        onSubmit: () => {},
        validationSchema: InvestLowerValidationScheme({ swpFlag: false }),
        validateOnMount: true,
    });

    const validateArnFields = async (Values: ArnPayloadType) => {
        try {
            await dispatch(validateArn(Values));
            return true;
        } catch (err: any) {
            throw err;
        }
    };
    const handleSubmit = async () => {
        if (commonDetails?.stpAllow === IsAllow.No) {
            alert(dbCommercial.stp.notAllowed);
            return;
        }

        installmentFormik.submitForm();
        formik.submitForm();
        if (formik.isValid && installmentFormik.isValid) {
            const apiBody = parseToAPIStructure(
                installmentFormik,
                stpFromScheme,
                stpToScheme,
                idcwDetails,
                formik,
            );
            try {
                setLoading(true);
                if (commonDetails?.amc === 'RMF' && commonDetails?.scheme.slice(0, 2) === 'SC') {
                    if (Number(installmentFormik.values.amount) > NIPPON_MAX_AMOUNT) {
                        throw new Error('Amount cannot be greater than 200,000');
                    }
                }

                if (commonDetails?.amc === 'RMF') {
                    const cycleDates = [1, 15];
                    if (
                        !cycleDates.includes(installmentFormik.values.fromDate.getDate()) ||
                        !cycleDates.includes(installmentFormik.values.toDate.getDate())
                    ) {
                        throw new Error('Start and End date should be on cycle dates (1 and 15)');
                    }
                }
                if (
                    String(installmentFormik.values.installmentDay) !==
                    String(installmentFormik.values.fromDate.getDate())
                ) {
                    throw new Error('STP Day and start date are different');
                }
                if (installmentDiff % 1 !== 0 && !installmentFormik.values.perpetual) {
                    throw new Error('Invalid Installment');
                }
                if (Number(installmentFormik.values.amount) > stpFromScheme.availableAmount) {
                    throw new Error(dbCommercial.switch.switchFromAmountError);
                }
                const otpPayload = {
                    action: OTP_ACTIONS.stp,
                };
                if (
                    formik.values.investThrough === InvestThrough.arn ||
                    formik.values.investThrough === InvestThrough.ria
                ) {
                    const { distId, subBrokerARN, subDist, euin, euinDeclarationFlag, riaCode } =
                        apiBody.data[0].schemeOptions[0];
                    await validateArnFields({
                        amc: stpToScheme.fundAmcCode,
                        distId: !!formik.values.arn1
                            ? `${ArnPayloadKeys.ARN}-${formik.values.arn1}`
                            : '',
                        subBrokerARN: !!formik.values.arn3
                            ? `${ArnPayloadKeys.ARN}-${formik.values.arn3}`
                            : '',
                        subDist,
                        euin: !!formik.values.euinCode
                            ? `${ArnPayloadKeys.EUIN}${formik.values.euinCode}`
                            : '',
                        euinDeclarationFlag,
                        riaCode: !!formik.values.riaCode
                            ? `${formik.values.riaFlag}${formik.values.riaCode}`
                            : '',
                        planCode: stpToScheme.plan.toUpperCase(),
                    });
                }
                const res = await props.sendPhoneOTP(otpPayload);
                history.replace(`${CommercialRootPath}${STPPaths.otp}`, {
                    reqId: res.body.reqId,
                    otpRef: res.body.otpRef,
                    apiPayload: apiBody,
                });
            } catch (err: any) {
                alert(err.message);
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        async function getNewSchemeDetails() {
            try {
                setSchemeLoading(true);
                const { body = { data: {} as any } }: any = await props.getNewSchemeDetail({
                    isin: stpToScheme.isin,
                    amcCode: !!amcCode ? amcCode : '',
                });
                const details = formatRtaResponse(body.data);
                //[TODO: Add default values to SIP]
                const { sip: stp = null, bool: sipAllow } = isSipAllowed(details.stp);
                sortSip(stp);
                setStpDetails({
                    ...details.stp,
                });
                setCommonDetails({
                    ...details.commonDetails,
                    sipAllow:
                        details.commonDetails.sipAllow === IsAllow.YES
                            ? sipAllow
                            : details.commonDetails.sipAllow,
                });
                setSubPlanDetails(details.subPlans);
                installmentFormik.setFieldValue('frequency', Object.keys(stp)[0]);
            } catch (err: any) {
                alert(err.message);
            } finally {
                setSchemeLoading(false);
            }
        }
        getNewSchemeDetails();
    }, []);

    console.log(stpFromScheme, 'stpToScheme');

    return (
        <div className="curved-bg mf-investment switch-investment mf-payment">
            <h2 className="heading desktop_mode">
                <a onClick={() => history.goBack()}>
                    <img src="/images/left-arrow-black.svg" alt="icon" />
                </a>
                {dbCommercial.stp.heading}
                <div className="switch-heading" style={{ marginTop: 10 }}>
                    <span>{stpFromScheme.schemeName}</span>
                    <img src="/images/right-arrow-long-purple.svg" alt="icon" />
                    <span>{stpToScheme.schemeName}</span>
                </div>
            </h2>
            <div className="switch-mobile-heading mobile_mode">
                <h2 className="heading">
                    <a onClick={() => history.goBack()}>
                        <img src="/images/left-arrow-black.svg" alt="icon" />
                    </a>
                    {dbCommercial.stp.heading}
                </h2>
                <div className="switch-heading">
                    <div className="switch-mobile-from">
                        <p className="switch-txt">{dbCommercial.switch.from}</p>
                        <p className="switch-title">{stpFromScheme.schemeName}</p>
                    </div>
                    <img
                        className="switch-down-arrow"
                        src="/images/down-arrow-long-purple.svg"
                        alt="icon"
                    />
                    <div className="switch-mobile-to">
                        <p className="switch-txt">{dbCommercial.switch.to}</p>
                        <p className="switch-title">{stpToScheme.schemeName}</p>
                    </div>
                </div>
                <div className="mobile-profile-details">
                    <div className="mobile-profile-details-inner">
                        <h4> {dbCommercial.stp.stpDetails}</h4>
                        <div className="mobile-profile-details-links">
                            <a onClick={() => setDrawer(true)}>
                                View <img src="/images/right-arrow-purple.svg" alt="icon" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="curved-bg-content">
                <div className="mf-investment-left">
                    <div className="investment-mode">
                        <InvestMentMode
                            plan={
                                (stpToScheme.plan.toUpperCase() as PlanTypes) || PlanTypes.Reggular
                            }
                            formikState={formik}
                            setEuin={setEuin}
                        />
                        <div className="investment-details">
                            <h3>
                                <img src="/images/investment-details.svg" alt="icon" />
                                {dbCommercial.exploreMfs.mfInvestment.investmentDetails}
                            </h3>
                            {!!commonDetails &&
                                !!subPlanDetails &&
                                commonDetails.isDividend.toLowerCase() === 'true' && (
                                    <IdcwOptions
                                        subPlans={subPlanDetails}
                                        setIdcwDetails={setIdcwDetails}
                                    />
                                )}
                            <InstallmentFields
                                formik={installmentFormik}
                                schemeDetails={stpDetails}
                                rtaName={stpFromScheme.rtaName}
                                setInstallmentDiff={setInstallmentDiff}
                                amc={stpToScheme.fundAmcCode || stpToScheme.amc}
                            />
                            <div className="mf-investment-bottom">
                                <div className="disclaimers">
                                    <FormControl>
                                        <FormControlLabel
                                            className="inline-checkbox"
                                            control={
                                                <Checkbox
                                                    name="terms-conditions"
                                                    onChange={() => {
                                                        formik.setFieldValue(
                                                            'isChecked',
                                                            !formik.values.isChecked,
                                                        );
                                                    }}
                                                    checked={formik.values.isChecked}
                                                    disabled={loading}
                                                />
                                            }
                                            label={
                                                <>
                                                    {
                                                        dbCommercial.exploreMfs.mfInvestment
                                                            .disclaimers
                                                    }
                                                    <a onClick={() => setShow(!show)}>
                                                        {
                                                            dbCommercial.exploreMfs.mfInvestment
                                                                .termsLink
                                                        }
                                                    </a>
                                                    {dbCommercial.exploreMfs.mfInvestment.of}
                                                    <span>
                                                        {
                                                            dbCommercial.exploreMfs.mfInvestment
                                                                .mfCentral
                                                        }
                                                    </span>
                                                </>
                                            }
                                        />
                                        {formik.touched.isChecked && (
                                            <FormHelperText
                                                style={{
                                                    color: 'red',
                                                    fontSize: 14,
                                                    textAlign: 'left',
                                                }}
                                            >
                                                {formik.errors.isChecked}
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </div>
                                <div className="buttons">
                                    <SubmitButtonWithLoader
                                        label={dbCommercial.redemption.proceedBtn}
                                        labelWhileLoading="Submitting.."
                                        loading={loading}
                                        className="customBtn "
                                        onClick={handleSubmit}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Dialog
                    open={false}
                    onClose={() => history.goBack()}
                    maxWidth={'sm'}
                    aria-labelledby="transmission-main-modal"
                >
                    <div className="note-modals transmission-main-modal">
                        <h3>{dbCommercial.exploreMfs.inactiveScheme}</h3>
                        <p>{dbCommercial.exploreMfs.inactiveSchemeInfo}</p>
                        <div className="note-modals-btns">
                            <Button className="customBtn" onClick={() => history.goBack()}>
                                {dbCommercial.exploreMfs.okay}
                            </Button>
                        </div>
                    </div>
                </Dialog>
                <SwitchRight
                    dbCommercial={dbCommercial}
                    switchFromScheme={stpFromScheme}
                    switchToScheme={stpToScheme}
                    stpFlag={true}
                />
            </div>
            <NomineePopup folio={stpFromScheme?.folio.toString()} />
            <Dialog fullWidth maxWidth={'lg'} open={show} aria-labelledby="terms-modal">
                <div className="terms-modal">
                    <div className="heading">
                        <h2>{common.termsConditions}</h2>
                        <a className="close">
                            <img
                                onClick={() => setShow(!show)}
                                src="/images/close-white.svg"
                                alt="icon"
                            />
                        </a>
                    </div>
                    <div className="content-outer">
                        <div className="content-inner">
                            <p>{dbCommercial.termsModal.switch.info1}</p>
                            <p>
                                <b>{dbCommercial.termsModal.switch.note}</b>
                                {dbCommercial.termsModal.switch.info2}
                            </p>
                        </div>
                    </div>
                </div>
            </Dialog>
            <Dialog fullWidth maxWidth={'lg'} open={euin} aria-labelledby="terms-modal">
                <div className="terms-modal">
                    <div className="heading">
                        <h2>{common.euinDeclaration}</h2>
                        <a className="close" onClick={() => setEuin(!euin)}>
                            <img src="/images/close-white.svg" alt="icon" />
                        </a>
                    </div>
                    <div className="content-outer">
                        <div className="content-inner">
                            <p>{dbCommercial.euinModal.info}</p>
                        </div>
                    </div>
                </div>
            </Dialog>
            <RtaSchemeLoadingDialog open={schemeLoading} />
            <SwipeableDrawer
                anchor={'bottom'}
                open={openDrawer}
                onClose={() => setDrawer(false)}
                onOpen={() => setDrawer(true)}
                className="explore-mf-drawer profile-details-drawer stp-profile"
            >
                <div className="filters-drawer-total">
                    <div className="filters-top">
                        <h5>
                            <img
                                src="/images/right-arrow-long-black.svg"
                                alt="icon"
                                onClick={() => setDrawer(false)}
                            />
                            {dbCommercial.stp.stpDetails}
                        </h5>
                    </div>
                    <div className="filters-drawer-content">
                        <div className="profile-details-drawer">
                            <SwitchRight
                                dbCommercial={dbCommercial}
                                switchFromScheme={stpFromScheme}
                                switchToScheme={stpToScheme}
                                desktopHeading={false}
                            />
                        </div>
                    </div>
                </div>
            </SwipeableDrawer>
        </div>
    );
};

export default connect(null, { getNewSchemeDetail, sendPhoneOTP })(STPInvestment);
